import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE } from "@/constant"
import { PropertyTypeV2 } from "commonModule/services/common"
import { RootState } from "stores/store"
import { markStates } from "utils/misc"

import { MultiUnitInitialState } from "./types"

export const initialState: MultiUnitInitialState = {
  property: {} as PropertyTypeV2,
  amenities: [],
  pmsSystem: "",
  attachments: [],
  multiUnits: null,
  multiUnitSummary: null,
  isLoading: false,
  state: {
    startDate: null,
    endDate: null,
    adultCount: 0,
    childrenCount: 0,
    numberOfGuest: 0,
    petAllowed: false,
    limit: NO_OF_PROERTIES_PER_PAGE_IN_LISTING_PAGE,
    noOfDays: 0,
    numberOfBedroom: 0,
    minBed: 0,
    numberOfBathroom: 0,
    page: 0,
    isMultiUnitsCalendarOpen: false,
    isMultiUnitGuestPopoverOpen: false,
  },
}

export const multiUnitSlice = createSlice({
  name: "multiUnit",
  initialState,
  reducers: {
    resetMultiUnitStore: (state) => {
      markStates(initialState, state)
    },
    markMultiUnit: (
      state,
      action: PayloadAction<Partial<MultiUnitInitialState>>,
    ) => {
      markStates(action.payload, state)
    },
    markMultiUnitStore: (
      state,
      action: PayloadAction<Partial<MultiUnitInitialState["state"]>>,
    ) => {
      markStates(action.payload, state.state)
    },
    markMultiUnitLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const {
  markMultiUnit,
  resetMultiUnitStore,
  markMultiUnitStore,
  markMultiUnitLoading,
} = multiUnitSlice.actions

export const selectMultiUnit = (state: RootState) => state.multiUnitReducer
export const selectMultiUnitStore = (state: RootState) =>
  state.multiUnitReducer.state
export const selectMultiUnitsData = (state: RootState) =>
  state.multiUnitReducer.multiUnits
export const selectMultiUnitsSummary = (state: RootState) =>
  state.multiUnitReducer.multiUnitSummary
export const selectMultiUnitsAmenities = (state: RootState) =>
  state.multiUnitReducer.amenities
export const selectMultiUnitsAttachments = (state: RootState) =>
  state.multiUnitReducer.attachments
export const selectMultiUnitsPmsSystem = (state: RootState) =>
  state.multiUnitReducer.pmsSystem
export const selectMultiUnitsProperty = (state: RootState) =>
  state.multiUnitReducer.property

export const selectMultiUnitsLoading = (state: RootState) =>
  state.multiUnitReducer.isLoading

export default multiUnitSlice.reducer
